function directive(Global) {
    return {
        transclude : false,
        link: function ($scope, element) {

        }
    };
}

directive.$inject = ['Global'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/alert/alert.js
 **/